/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-08-10 10:18:18
 * @LastEditors: szj
 * @LastEditTime: 2023-08-10 10:19:16
 */
//bus.js
import mitt from 'mitt'
export default mitt()